/*
 Landed by HTML5 UP
 html5up.net | @ajlkn
 Free for personal and commercial use under the CCA 3.0 license (html5up.net/license)
 */

(function($) {

    skel.breakpoints({
        xlarge: '(max-width: 1680px)',
        large: '(max-width: 1200px)',
        medium: '(max-width: 990px)',
        small: '(max-width: 736px)',
        xsmall: '(max-width: 480px)'
    });

    window.isMobile = function() {
        var check = false;
        (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
        return check;
    };

    $(function() {

        var $window = $(window),
            $body = $('body');

        // Disable animations/transitions until the page has loaded.
        $body.addClass('is-loading');

        $window.on('load', function() {
            window.setTimeout(function() {
                $body.removeClass('is-loading');
            }, 0);
        });

        // Touch mode.
        if (skel.vars.mobile)
            $body.addClass('is-touch');

        // Fix: Placeholder polyfill.
        $('form').placeholder();





        headerF();

        // Prioritize "important" elements on medium.
        skel.on('-large', function() {

            $(".sub_menu_inner").removeAttr('style');


        });
        skel.on('+medium -medium', function() {
            $.prioritize(
                '.important\\28 medium\\29',
                skel.breakpoint('medium').active
            );
            $(".box-search").appendTo("#navPanel");
            $(".search-wrapper").addClass("focused");
            $('body').addClass('ccccc');
            $(".sub_menu_inner").removeAttr('style');




        });
        // Prioritize "important" elements on medium.
        skel.on('-medium', function() {
            $('body').addClass('aaaaaaa');
            $(".box-search").insertAfter("#nav");
            $(".search-wrapper").removeClass("focused");
            $(".sub_menu_inner").removeAttr('style');




        });



        // Scrolly links.
        $('.scrolly').scrolly({
            speed: 2000
        });

        // Dropdowns.
        $('#nav > ul').dropotron({
            alignment: 'right',
            hideDelay: 350
        });


        // Off-Canvas Navigation.

        // Title Bar.
        $(
            '<div id="titleBar">' +
            '<a href="#navPanel" class="toggle"></a>' +
            '<span class="title">' + $('#logo').html() + '</span>' +
            '</div>'
        )
            .appendTo($body);

        // Navigation Panel.
        $(
            '<div id="navPanel">' +
            '<nav>' +
            ' <ul class="nav-mo">' +
            $('#nav').navList() +
            '</ul>' +
            '</nav>' +
            '</div>'
        )
            .appendTo($body)
            .panel({
                delay: 500,
                hideOnClick: true,
                hideOnSwipe: true,
                resetScroll: true,
                resetForms: true,
                side: 'left',
                target: $body,
                visibleClass: 'navPanel-visible',
                removeClass: 'navPanel-visibleRight'
            });



        $(
            '<div id="titleBarRight">' +
            '<a href="#navPanelRight" class="toggle"></a>' +
            // '<span class="title">' + $('#logo').html() + '</span>' +
            '</div>'
        )
            .appendTo($body);

        // Navigation Panel.
        $(
            '<div id="navPanelRight">' +
            '<nav>' +
            ' <ul class="nav-mo">' +
            $('.sub_menu_inner').navList() +
            '</ul>' +
            '</nav>' +
            '</div>'
        )
            .appendTo($body)
            .panel({
                delay: 500,
                hideOnClick: true,
                hideOnSwipe: true,
                resetScroll: true,
                resetForms: true,
                side: 'right',
                target: $body,
                visibleClass: 'navPanel-visibleRight',
                removeClass: 'navPanel-visible'
            });





        if ($('body') == ".navPanel-visibleRight") {
            $('body').removeClass('navPanel-visible');
            console.log('aaa');
        } else if ($('body') == ".navPanel-visible") {
            $('body').removeClass('navPanel-visibleRight');
        }
        $("#titleBarRight").click(function() {

            if ($('body').hasClass("navPanel-visible")) {

                $('body').removeClass('navPanel-visible');

            }

        });
        $("#titleBar").click(function() {

            if ($('body').hasClass("navPanel-visibleRight")) {

                $('body').removeClass('navPanel-visibleRight');

            }

        });

        // Fix: Remove navPanel transitions on WP<10 (poor/buggy performance).
        if (skel.vars.os == 'wp' && skel.vars.osVersion < 10)
            $('#titleBar, #navPanel, #page-wrapper')
                .css('transition', 'none');


        // Parallax.
        // Disabled on IE (choppy scrolling) and mobile platforms (poor performance).
        if (skel.vars.browser == 'ie' || skel.vars.mobile) {

            $.fn._parallax = function() {

                return $(this);

            };

        } else {

            $.fn._parallax = function() {

                $(this).each(function() {

                    var $this = $(this),
                        on, off;

                    on = function() {

                        $this
                            .css('background-position', 'center 0px');

                        $window
                            .on('scroll._parallax', function() {

                                var pos = parseInt($window.scrollTop()) - parseInt($this.position().top);

                                $this.css('background-position', 'center ' + (pos * -0.15) + 'px');

                            });

                    };

                    off = function() {

                        $this
                            .css('background-position', '');

                        $window
                            .off('scroll._parallax');

                    };

                    skel.on('change', function() {

                        if (skel.breakpoint('medium').active)
                            (off)();
                        else
                            (on)();

                    });

                });

                return $(this);

            };

            $window
                .on('load resize', function() {
                    $window.trigger('scroll');
                });

        }

        // Spotlights.
        var $spotlights = $('.spotlight');

        $spotlights
            ._parallax()
            .each(function() {

                var $this = $(this),
                    on, off;

                on = function() {

                    // Use main <img>'s src as this spotlight's background.
                    $this.css('background-image', 'url("' + $this.find('.image.main > img').attr('src') + '")');

                    // Enable transitions (if supported).
                    if (skel.canUse('transition')) {

                        var top, bottom, mode;

                        // Side-specific scrollex tweaks.
                        if ($this.hasClass('top')) {

                            mode = 'top';
                            top = '-20%';
                            bottom = 0;

                        } else if ($this.hasClass('bottom')) {

                            mode = 'bottom-only';
                            top = 0;
                            bottom = '20%';

                        } else {

                            mode = 'middle';
                            top = 0;
                            bottom = 0;

                        }

                        // Add scrollex.
                        $this.scrollex({
                            mode: mode,
                            top: top,
                            bottom: bottom,
                            initialize: function(t) { $this.addClass('inactive'); },
                            terminate: function(t) { $this.removeClass('inactive'); },
                            enter: function(t) { $this.removeClass('inactive'); },

                            // Uncomment the line below to "rewind" when this spotlight scrolls out of view.

                            //leave:    function(t) { $this.addClass('inactive'); },

                        });

                    }

                };

                off = function() {

                    // Clear spotlight's background.
                    $this.css('background-image', '');

                    // Disable transitions (if supported).
                    if (skel.canUse('transition')) {

                        // Remove scrollex.
                        $this.unscrollex();

                    }

                };

                skel.on('change', function() {

                    if (skel.breakpoint('medium').active)
                        (off)();
                    else
                        (on)();

                });

            });

        // Wrappers.
        var $wrappers = $('.wrapper');

        $wrappers
            .each(function() {

                var $this = $(this),
                    on, off;

                on = function() {

                    if (skel.canUse('transition')) {

                        $this.scrollex({
                            top: 250,
                            bottom: 0,
                            initialize: function(t) { $this.addClass('inactive'); },
                            terminate: function(t) { $this.removeClass('inactive'); },
                            enter: function(t) { $this.removeClass('inactive'); },

                            // Uncomment the line below to "rewind" when this wrapper scrolls out of view.

                            //leave:    function(t) { $this.addClass('inactive'); },

                        });

                    }

                };

                off = function() {

                    if (skel.canUse('transition'))
                        $this.unscrollex();

                };

                skel.on('change', function() {

                    if (skel.breakpoint('medium').active)
                        (off)();
                    else
                        (on)();

                });

            });

        // Banner.
        var $banner = $('#banner');

        $banner
            ._parallax();

    });
    // Search Toggle //

    // Quick proof of concept
    // Would like to make CSS only


    var searchWrapper = document.querySelector('.search-wrapper'),
        searchInput = document.querySelector('.search-input');
    document.addEventListener('click', function(e) {
        if (searchWrapper != null) {
            if (~e.target.className.indexOf('search')) {
                searchWrapper.classList.add('focused');
                searchInput.focus();
            } else {
                searchWrapper.classList.remove('focused');
            }
        }
    });

    //$('.accordion-step h3').append('<i class="icon icon--arrow"></i>')
    $('.accordion-step h3').append('<span class="arrow"></span>');
    //# sourceURL=pen.js
    equalheight = function(container) {

        var currentTallest = 0,
            currentRowStart = 0,
            rowDivs = new Array(),
            $el,
            topPosition = 0;
        $(container).each(function() {

            $el = $(this);
            $($el).height('auto')
            topPostion = $el.position().top;

            if (currentRowStart != topPostion) {
                for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
                    rowDivs[currentDiv].height(currentTallest);
                }
                rowDivs.length = 0; // empty the array
                currentRowStart = topPostion;
                currentTallest = $el.height();
                rowDivs.push($el);
            } else {
                rowDivs.push($el);
                currentTallest = (currentTallest < $el.height()) ? ($el.height()) : (currentTallest);
            }
            for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
                rowDivs[currentDiv].height(currentTallest);
            }
        });
    }
    // menu
    function headerF() {

        $(window).scroll(function() {
            var scrollTop = $(window).scrollTop();
            if (scrollTop > 49) {
                $('body').addClass('header-fixed');
            } else {
                $('body').removeClass('header-fixed');
            }
            // change the style of the navbar when the user scrolls into the next zone.
            // get the distance of the 2nd section from the top of the page - height of header.

        });

        $("#nav ul").hover(function() {
            $('#nav ul li.active').toggleClass('active_hide');
        });
    }

})(jQuery);

function accordion() {

    $(function() {
        var Accordion = function(el, multiple) {
            this.el = el || {};
            this.multiple = multiple || false;

            // Variables privadas
            var links = this.el.find('.link');
            // Evento
            links.on('click', {
                el: this.el,
                multiple: this.multiple
            }, this.dropdown)
        }

        Accordion.prototype.dropdown = function(e) {
            var $el = e.data.el;
            $this = $(this),
                $next = $this.next();

            $next.slideToggle();
            $this.parent().toggleClass('open');

            if (!e.data.multiple) {
                $el.find('.submenu').not($next).slideUp().parent().removeClass('open');
            };
        }

        var accordion = new Accordion($('#accordion'), false);
    });
}

function selectholder() {
    $(function() {
        $('.selectholder').each(function() {
            $(this).children().hide();
            var description = $(this).children('label').text();
            $(this).append('<span class="desc">' + description + '</span>');
            $(this).append('<span class="pulldown"></span>');
            // set up dropdown element
            $(this).append('<div class="selectdropdown"></div>');
            $(this).children('select').children('option').each(function() {
                if ($(this).attr('value') != '0') {
                    $drop = $(this).parent().siblings('.selectdropdown');
                    var name = $(this).text();
                    $drop.append('<span>' + name + '</span>');
                }
            });
            // on click, show dropdown
            $(this).click(function() {
                if ($(this).hasClass('activeselectholder')) {
                    // roll up roll up
                    $(this).children('.selectdropdown').slideUp(200);
                    $(this).removeClass('activeselectholder');
                    // change span back to selected option text
                    if ($(this).children('select').val() != '0') {
                        $(this).children('.desc').fadeOut(100, function() {
                            $(this).text($(this).text());
                            $(this).fadeIn(100);
                        });
                    }
                } else {
                    // if there are any other open dropdowns, close 'em
                    $('.activeselectholder').each(function() {
                        $(this).children('.selectdropdown').slideUp(200);
                        // change span back to selected option text
                        if ($(this).children('select').val() != '0') {
                            $(this).children('.desc').fadeOut(100, function() {
                                $(this).text($(this).text());
                                $(this).fadeIn(100);
                            });
                        }
                        $(this).removeClass('activeselectholder');
                    });
                    // roll down
                    $(this).children('.selectdropdown').slideDown(200);
                    $(this).addClass('activeselectholder');
                    // change span to show select box title while open
                    if ($(this).children('select').val() != '0') {
                        $(this).children('.desc').fadeOut(100, function() {
                            $(this).text($(this).siblings("select").children("option[value=0]").text());
                            $(this).fadeIn(100);
                        });
                    }
                }
            });
        });
        // select dropdown click action
        $('.selectholder .selectdropdown span').click(function() {
            $(this).siblings().removeClass('active');
            $(this).addClass('active');
            var value = $(this).text();
            $(this).parent().siblings('select').val(value);
            $(this).parent().siblings('.desc').fadeOut(100, function() {
                $(this).text(value);
                $(this).fadeIn(100);
            });
        });

    });


}

$(window).load(function() {
    equalheight('.service_content .heightA');

    var dataMenu = $("#sumMenu").data('submenu');



    var submenuM = $("#accordion").clone().attr('class', 'medium-submenuV2');
    // var submenu = $("#accordion").find("a").clone();
    console.log(submenuM);

    var newTdM = $('<div></div>').html(submenuM).attr('class', 'medium-submenu');

// var newTd = $('<div></div>').html(submenu).attr('class', 'medium-submenu');
    $("#navPanel #" + dataMenu).append(newTdM);

    var down = $("#" + dataMenu).children('a.link');
//     // down.hide();
    $("#" + dataMenu).children('a.link').remove();
    var downText = down.text();

    $("#" + dataMenu).prepend('<div class="link depth-0" id="down-swb">'+ downText + '</div>');


//  if ($("#accordion").find(".link").next( "ul") !== ".submenu" ) {

//     var submenu3 = $("#accordion").find(".link").next("ul").attr('class', 'medium-submenuV3');
//     var newTd3 = $('<div></div>').html(submenu3).attr('class', 'in-submenu3');
//     // $(this).append(newTd3);
//     console.log( $(submenu3));
//  }else{
// console.log( $(this));
//  }

    if (!$("#"+dataMenu).children().hasClass('medium-submenu')) {
        $(this).addClass('chevron-down');

    } else{
        $(this).removeClass('chevron-down');

    };

    $("#down-swb").on('click', function() {
        $(this).parent().toggleClass('open');

    });


});


$(window).resize(function() {
    equalheight('.service_content .heightA');


});